export default __webpack_public_path__ + "static/media/commverge_icon.c8822bd9.png";